export default "__VITE_ASSET__8Jlno85a__"